/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { INVITATION_FRAGMENT } from '../fragments'

export const GET_INVITATION = gql`
  query GetInvitation($id: ID!) {
    invitation(id: $id) {
      ...Invitation
    }
  }
  ${INVITATION_FRAGMENT}
`
